import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { SectionWrapper, ContainerWrapper, FlexLeft, NavStrip, HelmetTitle } from "../../../Components/Utils";
import { Body } from "../../Certificates";
import Layout from "../../../Components/Layout";
import Navbar from "../../BannerItems/Components/Navigation";

import TestLogo from "../../../Images/Network/default-logo.jpg";

const resizel = require('../../../Components/Utils/EqualHeight');

const FlexStart = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
const AlumnusSlate = styled(FlexStart)`
  border: none;
  flex-direction: column;
  margin: 10px;  
  min-height: 300px;
  overflow: hidden;
  padding: .5rem;
  text-align: left;
  width: 310px;
  flex: 1 0 auto;
`;
const LogoStyle = styled.div`
  height: 114px;
  width: 85%;
  padding: 1rem;

  a {
    border: none;
    background: none;
    > img {
        height: auto;
        max-height: 100%;
        width: auto;
        max-width: 100%;
        object-fit: contain;
        vertical-align: top;
      }
  } 
`;

const BodyStyle = styled(FlexStart)`
  flex-direction: column;
  font-size: 95%;
  word-break: break-word;
  min-height: 362px;
  max-height: 486px;
  overflow-y: auto;
  flex: 1;
  p {
    margin: .3rem 0;
  }
  small {
    display: block;
    margin: .2rem 0;
  }
  a {
    font-size: 95%;
  }
`;
class AlumnisCorner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alumniTiki: [] };
  }
  componentDidMount() {
    window.scrollTo(0,0);
    tikiGet('alumniTiki', this);
    resizel.addResize(document.getElementsByClassName('abodyStye'));
  }
  
  render() {
    return (
      <div className="App">
        <HelmetTitle title="Alumni" />
        <Layout
          head={
            <React.Fragment>
              <Navbar />
              <NavStrip />
            </React.Fragment>
          }
          body={
            <Alumnus alumniData={this.state.alumniTiki} />
          }
        />  
      </div>
    )
  }
}



function Alumnus ({alumniData}) {
  return (
    <SectionWrapper backgroundColor="white" mb="3rem">
      <ContainerWrapper textAlign="center">
        <h3 className="text-left">Alumni</h3>
        <p className="text-left">Each venture below is lead by a founder who successfully completed a Transnational Venture Scalecamp. We encourage you to connect with these growth-oriented ventures for partnerships, investments, and other business opportunities.</p>
        <FlexLeft style={{flexWrap: "wrap"}}>
          {
            alumniData && alumniData.sort((a, b) => {
              let a_ = a.company.toUpperCase();
              let b_ = b.company.toUpperCase();
              if (a_ < b_) { return -1; }
              if (a_ > b_) { return 1; }
              return 0;
            }).map((alumnus, index) => (
              <AlumnusSlate key={`${alumnus.company}-${index}`} data-index={index}>
                <LogoStyle>
                  <a href={alumnus.logo} rel="noopener noreferrer" target="_blank" alt={alumnus.company}>
                    <img src={alumnus.logo !== "" ? alumnus.logo : TestLogo} alt={alumnus.company} title={alumnus.ivp}/>
                  </a>
                </LogoStyle>
                <BodyStyle className="abodyStyle">
                  <p><strong>{alumnus.company}</strong></p>
                  <small dangerouslySetInnerHTML={{__html: alumnus.valueProposition}} />
                  <small><strong>Alumnus: </strong>{alumnus.founder && alumnus.founder}</small>
                  <small><strong>Email: </strong>{alumnus.email && alumnus.email}</small>
                  <small><strong>Website: </strong><a href={alumnus.website && `http://${alumnus.website}`} rel="noopener noreferrer" target="_blank" alt={alumnus.company}>{alumnus.website}</a></small>
                  {alumnus.coFounder && <small><strong>Co-Founders:</strong></small>}
                  {alumnus.coFounder && <small dangerouslySetInnerHTML={{__html: alumnus.coFounder}} /> }
                  
                  
                </BodyStyle>

              </AlumnusSlate>
            ))
          }
        </FlexLeft>
      </ContainerWrapper>
    </SectionWrapper>
  );
}

export function tikiGet(tikiData, self) {
  const url = "https://lms.globalgers.co/partnershipAPI.php";
  return fetch(url, {
    method: 'get',
    headers: new Headers({
      "secret": "XKLJLKJKLJLK83833dsklfj28923kncdnlkwej383843j3k"
    }),
  }).then(response => {
    return response.json()
  }).then(res => {
    self.setState({[tikiData]: res});
    console.log('lms tiki', res);
  }).catch(error => {
    console.error("Error occured", error);
  })
}
export default withRouter(AlumnisCorner)



// WEBPACK FOOTER //
// ./src/Pages/Experiences/Alumni/index.js